import formatImages from './formatImages'

export default function formatItinerary(itinerary) {
  // The VPS response delivers the itinerary as an object ({ description, events }),
  // while the legacy endpoints return the days as a plain array. Normalize both
  // to the array of days before formatting.
  const days =
    itinerary && !Array.isArray(itinerary) && Array.isArray(itinerary.events)
      ? itinerary.events
      : itinerary

  if (!days || !days.length) return []
  return days.map(day => {
    let highlight = day.highlight
    if (day.highlight && day.highlight.image) {
      highlight = {
        ...day.highlight,
        image: formatImages(day.highlight.image, [
          'itineraries-and-destinations'
        ])
      }
    }
    return { ...day, highlight }
  })
}
